import React, { Fragment, useEffect, useState } from 'react';
export function Countdown() {
  const [seconds, setSeconds] = useState(86064);
  useEffect(() => {
    const timer = window.setInterval(() => setSeconds(value => Math.max(value - 1, 0)), 1000);
    return () => window.clearInterval(timer);
  }, []);
  const units: [string, number][] = [['HS', Math.floor(seconds / 3600)], ['MIN', Math.floor(seconds % 3600 / 60)], ['SEG', seconds % 60]];
  return <div className="flex justify-center gap-2 sm:gap-4" role="timer" aria-label="La oferta de lanzamiento termina pronto" data-id="element-345" data-mp="1ohg3ttlrmlik">
      {units.map(([label, value], index) => <Fragment key={label} data-id="element-346" data-mp="1xdxfcxy1kleu" data-mpi={index}>
          {index > 0 && <span aria-hidden="true" className="pt-3 text-2xl text-gold/50 sm:pt-4 sm:text-4xl" data-id="element-347" data-mp="1tddilvhdrjt8">
              :
            </span>}
          <div className="min-w-[72px] rounded-xl border border-gold/30 bg-surface px-3 py-2.5 text-center sm:min-w-[104px] sm:px-5 sm:py-3" data-id="element-348" data-mp="38x9xeswe2ewh">
            <div className="text-3xl font-black leading-none tabular-nums text-gold sm:text-5xl" data-id="element-349" data-mp="2c8ghgnards7j">
              {String(value).padStart(2, '0')}
            </div>
            <div className="mt-1 text-[10px] font-bold tracking-[.2em] text-zinc-500" data-id="element-350" data-mp="2h8l1gnavl52i">{label}</div>
          </div>
        </Fragment>)}
    </div>;
}